/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Verification
 */
export interface Verification {
    /**
     * Verification status, one of {@code pending}, {@code verified}, {@code unverified}, or {@code unavailable}.
     * @type {string}
     * @memberof Verification
     */
    status: string;
    /**
     * Verified address associated with the tax ID
     * @type {string}
     * @memberof Verification
     */
    verifiedAddress: string;
    /**
     * Verified business name associated with the tax ID
     * @type {string}
     * @memberof Verification
     */
    verifiedName: string;
}

/**
 * Check if a given object implements the Verification interface.
 */
export function instanceOfVerification(value: object): value is Verification {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('verifiedAddress' in value) || value['verifiedAddress'] === undefined) return false;
    if (!('verifiedName' in value) || value['verifiedName'] === undefined) return false;
    return true;
}

export function VerificationFromJSON(json: any): Verification {
    return VerificationFromJSONTyped(json, false);
}

export function VerificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Verification {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'verifiedAddress': json['verifiedAddress'],
        'verifiedName': json['verifiedName'],
    };
}

export function VerificationToJSON(json: any): Verification {
    return VerificationToJSONTyped(json, false);
}

export function VerificationToJSONTyped(value?: Verification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'verifiedAddress': value['verifiedAddress'],
        'verifiedName': value['verifiedName'],
    };
}

